export var UPDATE_LOCATION_INFORMATION = 'UPDATE_LOCATION_INFORMATION';
export var UPDATE_LOCATION = 'UPDATE_LOCATION';
export var UPDATE_LOCATION_SUGGESTIONS = 'UPDATE_LOCATION_SUGGESTIONS';
export var SET_WAITING_FOR_LOCATION = 'SET_WAITING_FOR_LOCATION';
export var LOCATION_DENIED = 'LOCATION_DENIED';